
@php
    $user = auth()->user();
    $isTutor = $user->onlyTutor();
@endphp


<template>
    <div>
        <br/>
        <div class="col-md-12 padding-left-0">
                <form method="POST" action="" @submit.prevent="save" id="newsletterForm">

                    <!--<br/>-->

                    <div class="form-group">
                        <label for="exampleFormControlInput1">{{ trans('lms.name') }}</label>
                        <input type="text" class="form-control" id="exampleFormControlInput1" name="name"
                                v-model="documentTemplate.name">
                    </div>
                    <!--<div class="form-group">-->
                        <!--<label for="layoutSelector">Layout</label>-->
                        <!--<select @change="handleLayoutChange" class="form-control" id="layoutSelector"-->
                                <!--name="layout"-->
                                <!--v-model="documentTemplate.layout">-->
                            <!--<option v-for="(layout, index) in layouts" :value="layout">{{layout}}</option>-->
                        <!--</select>-->
                    <!--</div>-->
                    <!--<div v-if="documentClasses" class="form-group">-->
                        <!--<label for="documentClassSelector">Class</label>-->
                        <!--<select class="form-control" name="document_class"-->
                                <!--id="documentClassSelector"-->
                                <!--v-model="documentTemplate.document_class"-->
                                <!--@change="handleClassChange"-->
                        <!--&gt;-->
                            <!--<option v-for="(documentClass, index) in documentClasses" :value="documentClass">-->
                                <!--{{documentClass}}-->
                            <!--</option>-->
                        <!--</select>-->
                    <!--</div>-->
                    <div v-if="isRequestPending && actionPending == ACTIONS.GET_TEMPLATES"
                         class="d-flex justify-content-center">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="form-group subject-container">
                        <label :for="getSubjectEditorId()">{{ trans('lms.Subject') }}</label>
                        <textarea class="form-control" ref="templateEditors" :id="getSubjectEditorId()"
                                  name="templateeditor" rows="3"
                                  v-model="documentTemplate.subject"
                        >
                            {{documentTemplate.subject}}
                        </textarea>
                    </div>
                    <div v-for="(template, index) in templates" class="form-group">
                        <label :for="createEditorId(index)">{{ trans('lms.Content') }}</label>
                        <textarea class="form-control" ref="templateEditors" :id="createEditorId(index)"
                                  name="templateeditor" rows="3"
                                  v-model="template.content"
                        >
                            {{template.content}}
                        </textarea>


                        <!-- Show only if user want it, and if its creation page (not on edit page) -->
                        <!--<div id="signatureSection" v-if="signature.length > 0" v-bind:class="getSignatureClass(signature.length)" style="margin-top: 10px" v-html="signature">-->
                            <!--{{ signature }}-->
                        <!--</div>-->
                        <!--<div v-else class="" v-bind:class="getSignatureClass(signature.length) alert alert-danger" style="margin-top: 10px">-->
                            <!--No signature for the current language-->
                        <!--</div>-->
                        <template v-if="signature.length > 0">
                            <div id="signatureSection" v-bind:class="getSignatureClass(currentUser.signature_toggle === 1)" style="margin-top: 10px" v-html="signature">
                                {{ signature }}
                            </div>
                        </template>
                        <!--<template v-else>-->
                            <!--<div id="signatureSection" v-bind:class="['alert', 'alert-danger', getSignatureClass(currentUser.signature_toggle === 1)]" style="margin-top: 5px">-->
                                <!--{{ trans('lms.NoSignature') }}-->
                            <!--</div>-->
                        <!--</template>-->


                        <br/>
                        <template v-if="signature.length > 0">
                            <div class="form-check">
                                <label class="form-check-label" for="signature_toggle">
                                    {{ trans('lms.SignatureToggle') }}
                                </label>

                                <input v-if="currentUser.signature_toggle === 1" class="form-check-input" type="checkbox" checked value="" id="signature_toggle"  @change="updateSignatureToggle" />
                                <input v-else class="form-check-input" type="checkbox" value="" id="signature_toggle"  @change="updateSignatureToggle" />

                            </div>
                        </template>

                        <!--<div v-if="currentUser.signature_toggle === 1 && documentTemplate.subject === undefined && signature.length > 0" style="margin-top: 10px" v-html="signature">-->
                            <!--{{ signature }}-->
                        <!--</div>-->
                        <!--<div v-if="currentUser.signature_toggle === 1 && documentTemplate.subject === undefined && signature.length === 0">-->
                            <!--No signature for the current language-->
                        <!--</div>-->

                    </div>

                    <div class="form-group backgroundCertificate">
                        <label>{{trans('lms.Document')}}</label>
                        <a href="#" class="btn btn-primary positive btn-xs" @click="backgroundImage(this)">{{ trans('lms.Attach') }}</a>
                        <span class="pathImage">{{removePath(attachment)}}</span>
                        <a href="#" v-bind:class="{ hidden: !documentTemplate.attachment_id }" class="btn btn-link negative btn-xs delete-image" @click="deleteAttachment()">{{ trans('lms.DeleteAttachment') }}</a>
                    </div>

                    <button type="submit" class="btn btn-primary positive mb-2">
                        <span v-if="isRequestPending && actionPending == ACTIONS.SAVE"
                              class="spinner-border spinner-border-sm" role="status" aria-hidden="false"></span>
                        {{ trans('lms.save') }}
                    </button>
                    <a v-if="documentTemplate.id" @click.prevent="modalPreview()" class="btn primary positive mb-2" target="_blank"
                        :href="'/admin/newsletter' + this.id()">{{ trans('lms.Preview') }}</a>
                    <a id="'back_button' + this.id()" class="btn btn-default neutral mb-2 back-button"
                       :href="'/admin/newsletter'" onclick="goBack(this)">{{ trans('lms.back') }}</a>
                </form>
        </div>

        <div class="modal-backdrop" v-show="isModalVisible">
            <div class="modal modalPreview"
                 role="dialog"
                 aria-labelledby="modalTitle"
                 aria-describedby="modalDescription"
                 >
                <header class="modal-header">
                    <button
                            type="button"
                            class="close"
                            @click="close"
                            style="float: right;"
                    >
                        x
                    </button>
                </header>
                <section class="modal-body" style="overflow-y: auto;">

                </section>
            </div>
        </div>

        <div class="overlay">
            <div class="file-overlay-wraper">
                <a id="close_file_overlay" class="close_overlay btn" href="#" @click="saveAttachment()">{{ trans('lms.close') }} X</a>
                <div class="row overlay_row" id="media_overlay">
                    <div style="display: none" class="col-md-2">
                        <tabs></tabs>
                    </div>
                    <div class="col-md-12">
                        <upload @close-overlay="saveAttachment()" view="thumbnail" mode ="overlay" show="false"></upload>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {merge} from 'lodash';

    export default {
        props: ['initialData', 'baseUrl', 'ckeditorState'],
        data() {
            return {
                ACTIONS: {
                    SAVE: 'save',
                    GET_TEMPLATES: 'getTemplates',
                    GET_PLACEHOLDERS: 'getPaceholders'
                },
                id: () => {
                    return this.documentTemplate.id ? '/' + this.documentTemplate.id : ''
                },
                documentClasses: this.initialData.documentClasses,
                placeholders: this.initialData.placeholders,
                templates: this.initialData.templates,
                layouts: this.initialData.layouts,
                currentUser: this.initialData.currentUser,
                signature: this.initialData.signature,
                documentTemplate: this.initialData.documentTemplate,
                isRequestPending: false,
                actionPending: '',
                attachment: this.initialData.attachment,
                isModalVisible: false,
                ckeditorDisabled: this.initialData.ckeditorDisabled
            };
        },
        mounted() {
            localStorage.setItem('media_id', 'internal');
            localStorage.setItem('media_type', 'groups');
            this.init();
        },
        watch: {
            templates: function () {
                var _this = this;

                Vue.nextTick(function() {
                    _this.initEditors();
                });
            },
            placeholders: function () {
                var _this = this;

                Vue.nextTick(function() {
                    _this.initEditors();
                });
            }
        },
        methods: {
            modalPreview() {
                var modalBody = document.querySelector('.modal-body');
                this.isModalVisible = true;
                axios.get('/admin/newsletter' + this.id())
                .then(res => {
                    modalBody.innerHTML = res.data.html
                    })
            },
            updateSignatureToggle() {

                let signatureSection = document.getElementById('signatureSection');

                let elem = document.getElementById('signature_toggle');

                let checked;
                if (elem.checked) {
                    checked = 1;
                    signatureSection.classList.add('signatureDisplayed');
                    signatureSection.classList.remove('signatureHidden');
                } else {
                    checked = 0;
                    signatureSection.classList.add('signatureHidden');
                    signatureSection.classList.remove('signatureDisplayed');
                }

                $.ajax({
                    type: 'PUT',
                    url: '/message/signature/update',
                    data: {
                        "checked": checked
                    },
                    success: function () {

                    }
                });
            },
            getSignatureClass(num) {

                if (num == 1) {
                    return 'signatureDisplayed';
                }

                return 'signatureHidden';
            },
            close() {
                this.isModalVisible = false;
            },
            backgroundImage(element) {
                $('.overlay').attr('style', 'display:block!important');
                $('body').attr('style', 'overflow: hidden');
            },
            saveAttachment(){
                this.documentTemplate.attachment_id = localStorage.getItem('id');
                this.attachment = localStorage.getItem('path');
                this.close_overlay();
            },
            deleteAttachment(){
                this.documentTemplate.attachment_id = null;
                this.attachment = null;
            },
            removePath(attachment){
                if(!attachment) {
                    return attachment;
                }

                return attachment.replace(/.*\//, '');
            },
            close_overlay() {
                $('.overlay').attr('style', 'display:none!important');
                $('body').attr('style', 'overflow: scroll');
            },
            createEditorId(index) {
                return 'templateEditor' + index;
            },
            getSubjectEditorId() {
                return 'subjectTemplateEditor' + this.id;
            },
            handleLayoutChange: function (e) {
                this.getTemplates();
            },
            handleClassChange: function (e) {
                this.getPlaceholders();
            },
            init() {
                axios.interceptors.request.use((config) => {
                    this.isRequestPending = true;
                    this.actionPending = config.action;
                    return config;
                });

                axios.interceptors.response.use((response) => {
                    this.isRequestPending = false;
                    this.actionPending = '';
                    return response;
                });

                this.initEditors();
            },
            initEditors() {
                let plugins = [
                            'placeholder',
                            // 'insertdropdown',
                            // 'insertImage',
                            // 'insertBackground',
                            'heading',
                            'fontFamily',
                            'fontSize',
                            'fontBackgroundColor',
                            'fontColor',
                            'highlight',
                            'removeFormat',
                            '|',
                            'bold',
                            'italic',
                            'strikethrough',
                            'underline',
                            'subscript',
                            'superscript',
                            'link',
                            'bulletedList',
                            'numberedList',
                            '|',
                            'alignment',
                            'outdent',
                            'indent',
                            '|',
                            // 'code',
                            'blockQuote',
                            'insertTable',
                            // 'mediaEmbed',
                            // 'htmlEmbed',
                            'undo',
                            'redo',
                            'specialCharacters',
                            'horizontalLine',
                            '|',
                            // 'changeOrientation',
                        ];
                let subjectPlugins = ['placeholder'];
                if (this.ckeditorDisabled == true) {
                    return;
                }

                var _this = this;
                this.initEditor(this.getSubjectEditorId(), function (content) {
                    //remove html tags
                    let regex = /(<([^>]+)>)/ig;
                    _this.documentTemplate.subject = content.replace(regex, "");
                }, {plugins: subjectPlugins, target: 'subject', index: null});
                this.templates.forEach((template, index) => {
                    var editorId = _this.createEditorId(index);

                    _this.initEditor(editorId, function (content) {
                        template.content = content;
                    }, {plugins: plugins, target: 'template', index: index});
                })
            },
            initEditor(editorId, onUpdate, editorConfig = null) {
                        let _this = this;
                        var colorPallete = [
                            {
                                color: 'rgb(0, 0, 0)',
                                label: 'Black'
                            },
                            {
                                color: 'rgb(77, 77, 77)',
                                label: 'Dim grey'
                            },
                            {
                                color: 'rgb(153, 153, 153)',
                                label: 'Grey'
                            },
                            {
                                color: 'rgb(230, 230, 230)',
                                label: 'Light grey'
                            },
                            {
                                color: 'rgb(255, 255, 255)',
                                label: 'White',
                                hasBorder: true
                            },
                            {
                                color: 'rgb(53,64,134)',
                                label: 'Königsblau'
                            },
                            {
                                color: 'rgb(230, 76, 76)',
                                label: 'Red'
                            },
                            {
                                color: 'rgb(230, 153, 76)',
                                label: 'Orange'
                            },
                            {
                                color: 'rgb(230, 230, 76)',
                                label: 'Yellow'
                            },
                            {
                                color: 'rgb(153, 230, 76)',
                                label: 'Light green'
                            },
                            {
                                color: 'rgb(76, 230, 76)',
                                label: 'Green'
                            },
                            {
                                color: 'rgb(76, 230, 153)',
                                label: 'Aquamarine'
                            },
                            {
                                color: 'rgb(76, 230, 230)',
                                label: 'Turqoise'
                            },
                            {
                                color: 'rgb(76, 153, 230)',
                                label: 'Light blue'
                            },
                            {
                                color: 'rgb(76, 76, 230)',
                                label: 'Blue'
                            },
                            {
                                color: 'rgb(153, 76, 230)',
                                label: 'Purple'
                            }
                        ];
                function handleError( error ) {
                    console.error( 'Error: ' + error );
                }
                var ckEditorElement = document.getElementById(editorId);
                const watchdog = new CKSource.EditorWatchdog();
                watchdog.setCreator( function( element, config ){
                    return CKSource.Editor
                        .create( element, config )
                        .then( function(editor){
                            editor.model.document.on('change:data', () => {
                                const data = editor.getData();
                                if(editorConfig.target == 'subject'){
                                    _this.documentTemplate.subject = data;
                                }
                                if(editorConfig.target == 'template'){
                                    _this.templates[editorConfig.index].content = data;
                                }
                            })
                            return editor;
                        } )
                } );

                watchdog
                .create( ckEditorElement, {
                    toolbar: {
                        items: editorConfig.plugins
                    },
                    placeholderConfig: {
                        types: this.placeholders[0].placeholders,
                        labels: this.placeholders[0].placeholders,
                        wrapper: ['{{', '}}'],
                    },
                    fontFamily: {
                        options: [
                            'default',
                            'Arial, Helvetica, sans-serif',
                            'Courier New, Courier, monospace',
                            'Georgia, serif',
                            'Lucida Sans Unicode, Lucida Grande, sans-serif',
                            'Tahoma, Geneva, sans-serif',
                            'Times New Roman, Times, serif',
                            'Trebuchet MS, Helvetica, sans-serif',
                            'Verdana, Geneva, sans-serif',
                            'Montserrat ,sans-serif',
                            'Open Sans ,sans-serif',
                            'NectarHeadline ,sans-serif',
                            'Spartan ,sans-serif',
                        ]
                    },
                    fontColor: {
                        colors: colorPallete,
                    },
                    fontBackgroundColor: {
                        colors: colorPallete,
                    },
                    image: {
                        // Configure the available styles.
                        styles: [
                            'alignLeft', 'alignCenter', 'alignRight'
                        ],

                        // Configure the available image resize options.
                        resizeOptions: [
                            {
                                name: 'resizeImage:original',
                                label: 'Original',
                                value: null
                            },
                            {
                                name: 'resizeImage:50',
                                label: '50%',
                                value: '50'
                            },
                            {
                                name: 'resizeImage:75',
                                label: '75%',
                                value: '75'
                            },
                        ],

                        toolbar: [
                            'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight',
                            '|',
                            'resizeImage',
                            '|',
                            'imageTextAlternative'
                        ]
                    },
                    table: {
                        contentToolbar: [
                            'tableColumn', 'tableRow', 'mergeTableCells','tableProperties', 'tableCellProperties'
                        ],
                        tableProperties: {
                            borderColors: colorPallete,
                            backgroundColors: colorPallete,
                            defaultProperties: {
                                // height: '250px',
                            }
                        },
                        tableCellProperties: {
                            borderColors: colorPallete,
                            backgroundColors: colorPallete,
                            defaultProperties: {
                                // height: '35px',
                            }
                        }
                    },
                    heading: {
                        options: [
                            {
                                model: 'blockParagraph',
                                view: {
                                    name: 'p',
                                    classes: 'block-paragraph',
                                    attributes: {
                                        spellcheck: 'false'
                                    }
                                },
                                title: 'Paragraph',
                                class: 'ck-heading_blockParagraph',
                                converterPriority: 'high'
                            },
                            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },

                        ]
                    },
                    language: document.documentElement.lang,
                    licenseKey: '',
                } )
                .catch( handleError );
            },
            getTemplates() {
                this.templates = [];
                axios.request({
                    url: 'templates' + this.id(),
                    method: 'post',
                    baseURL: this.baseUrl,
                    action: this.ACTIONS.GET_TEMPLATES,
                    data: {
                        layout: this.documentTemplate.layout,
                        document_class: this.documentTemplate.document_class,
                    }
                })
                    .then(({data}) => {
                        this.templates = data;
                        this.initEditors();
                    });
            },
            getPlaceholders() {
                axios.request({
                    method: 'post',
                    url: 'placeholders' + this.id(),
                    baseURL: this.baseUrl,
                    action: this.ACTIONS.GET_PLACEHOLDERS,
                    data: {
                        layout: this.documentTemplate.layout,
                        document_class: this.documentTemplate.document_class,
                    }
                })
                    .then(({data}) => {
                        this.placeholders = data;
                    });
            },
            save() {
                var method = this.id() ? 'put' : 'post';

                axios.request(
                    {
                        url: this.id(),
                        method: method,
                        baseURL: this.baseUrl,
                        action: this.ACTIONS.SAVE,
                        data: {
                            name: this.documentTemplate.name,
                            subject: this.documentTemplate.subject,
                            layout: this.documentTemplate.layout,
                            document_class: this.documentTemplate.document_class,
                            templates: this.templates,
                            attachment_id: this.documentTemplate.attachment_id
                        }
                    }
                )
                    .then(({data}) => {

                        // check if user is adding or editing the template
                        if(this.initialData.newsletter.create) {  // if creating
                            if (data.redirect) {
                                window.location.href = data.redirect;
                                return;
                            }
                            this.documentTemplate = data.documentTemplate;
                            this.templates = data.templates
                        } else {  // if editing
                            location.reload();
                        }

                        //location.reload();

                    });
            }
        }
    }
</script>

<style>
    .subject-container .ck-editor__editable_inline {
        min-height: unset;
    }
    .modal-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;

     
    }
@keyframes slidein {
    from {
    width:0px;
    }
    to {
    width:90%;
    }
}

    /*.modal {*/
        /*background: #FFFFFF;*/
        /*box-shadow: 2px 2px 20px 1px;*/
        /*overflow-x: auto;*/
        /*display: flex;*/
        /*flex-direction: column;*/
    /*}*/

    .modalPreview {
        max-width: 1300px;
        margin: 55px auto;
        background: #FFFFFF;
        box-shadow: 2px 2px 20px 1px;
        overflow-x: auto;
        display: flex;
        flex-direction: column;
        margin-top: 120px;
        animation-duration: .7s;
        animation-name: slidein;
    }

 

    /* .modal-header,
    .modal-footer {
        padding: 15px;
        display: flex;
    }

    .modal-header {
        border: none!important;
        justify-content: space-between;
    }

    .modal-footer {
        border: none!important;
        justify-content: flex-end;
    }

    .modal-body {
        position: relative;
        padding: 20px 10px;
        overflow-y: auto;
    }

    .btn-close {
        border: none;
        font-size: 20px;
        padding: 20px;
        cursor: pointer;
        font-weight: bold;
        background: transparent;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 10000;
    } */

    .btn-green {
        position: absolute;
        bottom: 20px;
        right: 10px;
    }

    .showMessageButton {
        display: none!important;
    }

    #newsletterForm {
        margin-bottom: 50px;
    }

    .modal-body .file {
        pointer-events: none;
    }

    .signatureDisplayed {
        display: block;
    }

    .signatureHidden {
        display: none;
    }

    tr{
        cursor: pointer;
    }
</style>
